import { render, staticRenderFns } from "./Salao.vue?vue&type=template&id=51da0161&"
import script from "./Salao.vue?vue&type=script&lang=js&"
export * from "./Salao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports